import React from "react";
import { Link } from "react-router-dom";
import pImg1 from "../../images/pricing/img-1.jpg";
import pImg2 from "../../images/pricing/img-2.jpg";
import pImg3 from "../../images/pricing/img-3.jpg";

interface PricingItem {
  prImg: string;
  pakage: string;
  price: string;
  subs: string;
  l1: string;
  l2: string;
  l3: string;
  l4: string;
  l5: string;
  shape?: string;
  shape2?: string;
}

interface PricingSectionProps {
  prClass?: string;
}

// ✅ Pricing data
const Pricing: PricingItem[] = [
  {
    prImg: pImg1,
    pakage: "Basic Package",
    price: "150",
    subs: "Monthly",
    l1: "Stylish makeup for bride.",
    l2: "Top label arrangement",
    l3: "Amazing meal & breakfast",
    l4: "Manicure & Pedicure",
    l5: "Full body Polish",
  },
  {
    prImg: pImg2,
    pakage: "Standard Package",
    price: "500",
    subs: "Monthly",
    l1: "Stylish makeup for bride.",
    l2: "Top label arrangement",
    l3: "Amazing meal & breakfast",
    l4: "Manicure & Pedicure",
    l5: "Full body Polish",
    shape: pImg1,
    shape2: pImg2,
  },
  {
    prImg: pImg3,
    pakage: "Luxury Package",
    price: "750",
    subs: "Yearly",
    l1: "Stylish makeup for bride.",
    l2: "Top label arrangement",
    l3: "Amazing meal & breakfast",
    l4: "Manicure & Pedicure",
    l5: "Full body Polish",
  },
];

const PricingSection: React.FC<PricingSectionProps> = ({ prClass }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={`wpo-pricing-section ${prClass || ""}`}>
      <div className="pricing-bg-image"></div>
      <div className="container">
        <div className="wpo-pricing-wrap">
          <div className="wpo-section-title">
            <h2 className="poort-text poort-in-right">Our Awesome Pricing Plan</h2>
            <p>
              From intimate gatherings to grand luxury weddings, we bring together
              creativity, organization, and passion to design every detail with precision.
            </p>
          </div>

          <div className="row">
            {Pricing.map((pricing, index) => (
              <div className="col col-lg-4 col-md-6 col-12" key={index}>
                <div className="wpo-pricing-item wow fadeInUp" data-wow-duration="1200ms">
                  <div className="pricing-image">
                    <img src={pricing.prImg} alt={pricing.pakage} />
                  </div>
                  <div className="wpo-pricing-item-inner">
                    <div className="wpo-pricing-top">
                      <div className="wpo-pricing-text">
                        <h4>{pricing.pakage}</h4>
                        <h2>
                          <small>$</small>
                          {pricing.price}
                          <span>/{pricing.subs}</span>
                        </h2>
                      </div>
                    </div>
                    <div className="wpo-pricing-bottom">
                      <div className="wpo-pricing-bottom-text">
                        <ul>
                          <li>{pricing.l1}</li>
                          <li>{pricing.l2}</li>
                          <li>{pricing.l3}</li>
                          <li>{pricing.l4}</li>
                          <li>{pricing.l5}</li>
                        </ul>
                        <Link onClick={ClickHandler} className="theme-btn" to="/pricing">
                          Choose Plan
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
